import { EditorPill } from './EditorPill'
import { PillNames } from './PillNames'
import { linkTitles, type PillLink } from './linkTitles'
import type { LucideIcon } from '@ttab/elephant-ui/icons'
import type { JSX } from 'react'

/**
 * A link list field on the editor surface for documents with no Yjs document to
 * read from, such as the frozen `usable`/`withheld`/`used` snapshot rendered by
 * PlainEditor. Sourced from the fetched document snapshot instead of
 * `useYValue`. The icon says which field it is, same as in the editable pill.
 */
export const LinkPillReadOnly = ({ field, links, Icon, emptyLabel, lead, hint }: {
  field: string
  links: PillLink[] | undefined
  Icon: LucideIcon
  emptyLabel: string
  lead?: string
  hint?: string
}): JSX.Element => {
  return (
    <EditorPill field={field} hasValue={!!links?.length || !!lead}>
      <>
        <Icon size={20} strokeWidth={1.75} aria-hidden className='shrink-0' />
        <PillNames names={linkTitles(links)} placeholder={emptyLabel} lead={lead} hint={hint} />
      </>
    </EditorPill>
  )
}
